import { render } from "./new-external-contact.vue?vue&type=template&id=54a1bc0c"
import script from "./new-external-contact.vue?vue&type=script&lang=js"
export * from "./new-external-contact.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__